import { render, staticRenderFns } from "./SupplierPrimaryKey.vue?vue&type=template&id=9c760e88&scoped=true&"
import script from "./SupplierPrimaryKey.vue?vue&type=script&lang=js&"
export * from "./SupplierPrimaryKey.vue?vue&type=script&lang=js&"
import style0 from "./SupplierPrimaryKey.vue?vue&type=style&index=0&id=9c760e88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c760e88",
  null
  
)

export default component.exports